import type { Game } from './games/GamesResponse';

export const ALL_CONFERENCES = 'all';

export interface Conference {
    name: string;
    abbreviation?: string;
}

function hasName(conference: Partial<Conference>): conference is Conference {
    return Boolean(conference.name);
}

export function gameConferences(game: Game, { includeLeagues }: { includeLeagues: boolean }): Conference[] {
    const conferences: Partial<Conference>[] = [
        { name: game.awayConfernceName, abbreviation: game.awayConfernceAbbreviation },
        { name: game.homeConfernceName, abbreviation: game.homeConfernceAbbreviation },
    ];
    if (!includeLeagues) return conferences.filter(hasName);

    const leagues: Partial<Conference>[] = [
        { name: game.awayTeamLeagueName },
        { name: game.homeTeamLeagueName, abbreviation: game.homeLeagueAbbreviation },
    ];
    return [...conferences, ...leagues].filter(hasName);
}

export function buildConferenceOptions(conferences: Conference[]): string[] {
    return [...new Set(conferences.map((conference) => conference.name))].sort();
}

export function isInConference(conferences: Conference[], selected: string): boolean {
    if (selected === ALL_CONFERENCES) return true;
    return conferences.some((conference) => conference.name === selected);
}

export function resolveConferenceQuery(conferences: Conference[], query: string | null): string | undefined {
    const cleanQuery = query?.trim().toLowerCase();
    if (!cleanQuery) return undefined;
    if (cleanQuery === ALL_CONFERENCES) return ALL_CONFERENCES;

    return conferences.find((conference) => conference.abbreviation?.trim().toLowerCase() === cleanQuery)?.name;
}
